import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';

export function StyledTextField(props: TextFieldProps) {
  return (
    <TextField
      variant="outlined"
      margin="none"
      inputProps={{
        style: {
          height: 2,
          padding: '22px 16px 26px 16px',
          backgroundColor: 'white',
          borderRadius: '5px'
        }
      }}
      autoComplete="off"
      {...props}
    />
  );
}
